import { useRouter } from 'expo-router';
import { useEffect } from 'react';
import { ActivityIndicator, Platform } from 'react-native';
import { Box } from '../src/components/primitives/Box';
import { useAuth } from '../src/contexts/AuthContext';
import { colors } from '../src/theme/colors';

export default function HomeScreen() {
  const router = useRouter();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        router.replace('/dashboard');
      } else if (Platform.OS === 'web') {
        router.replace('/landing');
      } else {
        router.replace('/login');
      }
    }
  }, [isAuthenticated, isLoading, router.replace]);

  return (
    <Box
      flex={1}
      alignItems="center"
      justifyContent="center"
      backgroundColor={colors.background.primary}
    >
      <ActivityIndicator size="large" color={colors.primary[500]} />
    </Box>
  );
}
